import { useLoggedInUser } from "components/LoggedInUserProvider";

interface IOptions {
  assignedUserId?: string;
  creatorId?: string;
}

interface IUseComplicatedRolesAndStatusesReturnType {
  isCurrentUserChiefOrSeniorVet?: boolean;
  isCurrentUserAssignedTrackVet?: boolean;
  isCurrentUserTrackVetAndCreator?: boolean;
  isCurrentUserAssigned?: boolean;
}

export const useComplicatedRolesAndStatuses = (
  options?: IOptions
): IUseComplicatedRolesAndStatusesReturnType => {
  const { assignedUserId, creatorId } = options;

  const {
    currentUser: { rh360Id: currentUserId, isSeniorVet, isTrackVet, isChiefVet }
  } = useLoggedInUser();

  const isCurrentUserChiefOrSeniorVet = [isSeniorVet, isChiefVet].some(Boolean);
  const isCurrentUserAssigned = currentUserId === assignedUserId;
  const isCurrentUserAssignedTrackVet = [
    isTrackVet,
    currentUserId === assignedUserId
  ].every(Boolean);
  const isCurrentUserTrackVetAndCreator = [
    isTrackVet,
    currentUserId === creatorId
  ].every(Boolean);

  return {
    isCurrentUserChiefOrSeniorVet,
    isCurrentUserAssigned,
    isCurrentUserAssignedTrackVet,
    isCurrentUserTrackVetAndCreator
  };
};
